// ============================================================================
// CASE ACCOUNTS HOOK — Phase 9b-2
// ============================================================================
// Fetches all accounts linked to a single case. The list is small enough that
// pagination is unnecessary — a typical case carries 1–3 account rows.

import { useState, useEffect, useCallback } from 'react';
import { caseAccountService } from '../../api/services/caseAccountService';
import type { CaseAccount } from '../../api/types/caseAccount.types';
import type { ID } from '../../api/types';

export const useCaseAccounts = (caseId: ID | undefined) => {
  const [data, setData] = useState<CaseAccount[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    if (!caseId) { setData([]); return; }
    setLoading(true); setError(null);
    try {
      const response = await caseAccountService.getByCase(caseId);
      setData(response.data ?? []);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, [caseId]);

  useEffect(() => { fetch(); }, [fetch]);

  return { data, loading, error, refetch: fetch };
};
